export default __webpack_public_path__ + "static/media/img8.72d9e7ca.jpeg";